import { useCallback, useRef } from "react";
import { API } from "../../data/siteData";
import { csrfHeaders } from "../../utils/csrf";

export default function useSessionHeartbeat({ endSession, setActiveUser, userRef }) {
  const lastHeartbeatRef = useRef(0);

  const heartbeat = useCallback(async () => {
    if (!userRef.current) return;
    const response = await fetch(`${API}/auth/heartbeat`, {
      method: "POST",
      credentials: "include",
      headers: csrfHeaders(),
    });
    if (!response.ok) {
      await endSession();
      return;
    }
    setActiveUser(await response.json());
    lastHeartbeatRef.current = Date.now();
  }, [endSession, setActiveUser, userRef]);

  return { heartbeat, lastHeartbeatRef };
}